import { Link, useParams } from 'react-router-dom';

import { Button, Page } from '@occc-app/design-system';
import { useGetMessagingCampaignById } from '@occc-app/dataAccessLayer/messagingCenter/queries';
import { useIsUserPermittedTo } from '@occc/utils-access-control';
import { Feature } from '@occc/utils-access-control';

import { getBreadcrumbLinks } from './messaging-campaign-details.utils';
import { MessagingCampaignDetailsPage } from './messaging-campaign-details.page';
import { EDIT_BUTTON_TITLE } from './messaging-campaign-details.constants';
import { Archive } from './components/archive/archive.component';

import { PAGE_SUBTITLE, DETAILS_PAGE_TITLE } from '../../messaging-center.constants';
import { routeCreator } from '../../messaging-center.utils';
import { MessagingCampaignTabs } from '../messaging-campaign-configure';
import { getIsEditableByStatus } from '../messaging-campaign-update/messaging-campaign-update.utils';
import { getIsArchivableByStatus } from '../messaging-campaign-archive/messaging-campaign-archive.utils';

export const MessagingCampaignDetailsPageContainer = () => {
  const { id: campaignId = '' } = useParams<{ id: string }>();
  const isUserPermittedToEdit = useIsUserPermittedTo(Feature.MESSAGING_CENTER_EDIT);
  const isUserPermittedToArchive = useIsUserPermittedTo(Feature.MESSAGING_CENTER_ARCHIVE);

  const { data: campaign, loading: campaignLoading } = useGetMessagingCampaignById(campaignId);

  const links = getBreadcrumbLinks(campaign?.title);

  const isEditable = getIsEditableByStatus(campaign?.status);
  const isArchivable = getIsArchivableByStatus(campaign?.status);

  const canShowEditButton = isUserPermittedToEdit && isEditable;
  const canShowArchiveButton = isUserPermittedToArchive && isArchivable;

  return (
    <Page
      browserTabTitle={DETAILS_PAGE_TITLE}
      pageHeaderProps={{
        title: campaign?.title || DETAILS_PAGE_TITLE,
        subtitle: campaign?.description || PAGE_SUBTITLE,
      }}
      actions={
        <>
          {canShowArchiveButton ? <Archive campaignId={campaignId} /> : null}
          {canShowEditButton ? (
            <Button
              color='secondary'
              variant='contained'
              component={Link}
              to={routeCreator.campaignUpdateWithTab(campaignId, MessagingCampaignTabs.Configure)}
              role='button'
            >
              {EDIT_BUTTON_TITLE}
            </Button>
          ) : null}
        </>
      }
      containerProps={{ variant: 'md' }}
    >
      <MessagingCampaignDetailsPage
        campaignData={campaign}
        loading={campaignLoading}
        breadcrumbLinks={links}
      />
    </Page>
  );
};
